import React from 'react';

export function SearchByPeriodOrientations() {
  return <h1>Orientações - Consulta por Período</h1>;
}
